// extracted by mini-css-extract-plugin
export default {"titleQuestion":"RegisterAuditorFormThirteen_titleQuestion__YvQ3R","privacyNoticeLink":"RegisterAuditorFormThirteen_privacyNoticeLink__FpRE3"};